var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"help-iframe","src":"https://socci.esa.int/www/gssc_iapplications/Quick_Start_Guide.html","frameborder":"0","allowfullscreen":""}})])
}]

export { render, staticRenderFns }